import { Component } from '@angular/core';
import { BaseIconComponent } from '../base-icon/base-icon.component';

@Component({
  selector: 'app-icon-shield',
  templateUrl: './icon-shield.component.html'
})
export class IconShieldComponent extends BaseIconComponent {
}
